module.exports = __webpack_public_path__ + "static/image2-2138af6fe2182825b47ffa16cbfcc74b.jpg";